import { useState } from 'react';
import { PinFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import PopOver from '@designSystem/PopOver';
import {
  PlotHover,
  PlotPopUp,
  StyledPopUpTitle,
  ClosingCross,
  StyledPopUpContent,
  Plot,
  UndefinedPlot,
  UndefinedPlotHover
} from './styles/SelectMismatchStyles';

const Marker = ({
  hover,
  disabled,
  onClick,
  markerId,
  lat,
  lng,
  color = 'white',
  address,
  zIndex
}: {
  disabled?: boolean;
  hover?: boolean;
  onClick?: CallableFunction;
  markerId?: string;
  color?: string;
  lat: number;
  lng: number;
  address?: string;
  zIndex?: number;
}) => {
  const { t } = useTranslation();
  const [showPopUp, setShowPopUp] = useState(true);

  if (markerId && markerId === 'center') {
    return (
      <PinFill style={{ fontSize: '1.5rem', color: '#4d4d4d', marginLeft: -11, marginTop: -36 }} />
    );
  }

  if (address && address[0] == '0') {
    if (hover) {
      return (
        <>
          <UndefinedPlotHover
            color={'rgba(' + color + ')'}
            data-testid="undefined-plot-hover"
            onClick={() => {
              setShowPopUp(true);
            }}
          />
          <PlotPopUp showPopUp={showPopUp}>
            <PopOver vertical="top" horizontal="right">
              <StyledPopUpTitle>
                {t('features.geomatch.selectedAddress', 'Selected Address')}
              </StyledPopUpTitle>
              <ClosingCross
                onClick={() => {
                  setShowPopUp(false);
                }}
              >
                X
              </ClosingCross>
              <StyledPopUpContent>{address}</StyledPopUpContent>
            </PopOver>
          </PlotPopUp>
        </>
      );
    }

    return (
      <UndefinedPlot
        color={'rgba(' + color + ')'}
        $disable={disabled}
        data-testid="undefined-plot"
        onClick={(e) => (onClick && !disabled ? onClick(e, { markerId, lat, lng }) : null)}
      />
    );
  }

  if (hover) {
    return (
      <>
        <PlotHover
          $color={color}
          data-testid="plot-hover"
          onClick={() => {
            setShowPopUp(true);
          }}
        />
        <PlotPopUp showPopUp={showPopUp}>
          <PopOver vertical="top" horizontal="right">
            <StyledPopUpTitle>
              {t('features.geomatch.selectedAddress', 'Selected Address')}
            </StyledPopUpTitle>
            <ClosingCross
              onClick={() => {
                setShowPopUp(false);
              }}
            >
              X
            </ClosingCross>
            <StyledPopUpContent>{address}</StyledPopUpContent>
          </PopOver>
        </PlotPopUp>
      </>
    );
  }

  return (
    <Plot
      $color={color}
      $disable={disabled}
      data-testid="plot"
      onClick={(e) => (onClick && !disabled ? onClick(e, { markerId, lat, lng }) : null)}
    />
  );
};

export default Marker;
